<button
  mat-icon-button
  color="primary"
  class="flex-initial button--square colorPicker_trigger"
  [matMenuTriggerFor]="colorMenu"
>
  <mat-icon svgIcon="palette"></mat-icon>
</button>

<mat-menu #colorMenu="matMenu" xPosition="before" class="colorPicker_panel">
  <app-color-picker [context]="context" [options]="options" [isEditMode]="matMenuTrigger.menuOpen"></app-color-picker>
</mat-menu>
